// WARNING: HTML entities passed to stripHTML will be returned in their literal form.
// Results from this function should not be used in unsafe contexts without escaping.
export function stripHTML(string) {
  const doc = new DOMParser().parseFromString(string, 'text/html');

  return doc.body.textContent || '';
}
